var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from "jquery";
import { Page } from "../common/Page";
var Newsletter = /** @class */ (function (_super) {
    __extends(Newsletter, _super);
    function Newsletter() {
        var _this = _super.call(this) || this;
        _this.form = $("form");
        _this.submit = _this.form.find(".submit");
        _this.conditionalRequired = _this.form.find(".conditional-required");
        _this.metadata = _this.form.find(".metadata");
        _this.form.find("[name=status]").on("change", function (e) {
            var $el = $(e.target);
            _this["set" + $el.val()]();
        });
        _this.setSubscribe();
        return _this;
    }
    Newsletter.prototype.setSubscribe = function () {
        this.form.attr("action", "//lucilledicaire.us3.list-manage.com/subscribe/post?u=c50ee383b5d02bd322255d0b7&id=efa4c52abe");
        this.submit.val(this.submit.attr("dataSubscribe"));
        this.conditionalRequired.attr("required", "required");
        this.metadata.slideDown(300);
    };
    Newsletter.prototype.setUnsubscribe = function () {
        this.form.attr("action", "//lucilledicaire.us3.list-manage.com/unsubscribe?u=c50ee383b5d02bd322255d0b7&id=efa4c52abe");
        this.submit.val(this.submit.attr("dataUnsubscribe"));
        this.conditionalRequired.removeAttr("required");
        this.metadata.slideUp(300);
    };
    return Newsletter;
}(Page));
export { Newsletter };
